
export default {
	props: {
		count: {
			type: Number,
			default: 0
		},
		customStyle: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		countNumber() {
			return this.count > 99 ? '99+' : this.count
		}
	}
}
